import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-custom mt-2" }
const _hoisted_2 = { class: "mt-5" }
const _hoisted_3 = { class: "p-field-label" }
const _hoisted_4 = { class: "mt-1" }
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = { class: "mt-3 d-flex align-items-center" }
const _hoisted_8 = { class: "px-2 warning-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KeypadCodeInput = _resolveComponent("KeypadCodeInput")
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_ElScrollbar, { class: "details-panel-content" }, {
      default: _withCtx(() => [
        _createVNode(_component_KeypadCodeInput, {
          key: _ctx.updateGuesttKey,
          modelValue: _ctx.keypadCode,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.keypadCode = $event)),
          label: _ctx.$t('AppResourceEP.KeypadCodePlaceHolder'),
          keypadCodeRequiredLength: _ctx.currentEntrancePlant.keypadCodeRequiredLength,
          fullWidth: !_ctx.isEdit,
          alreadyUsedCodes: _ctx.alreadyUsedCodes,
          disabled: _ctx.disabled,
          onErrorKeyCode: _ctx.handleErrorKeyCode,
          onKeyCodeEdited: _ctx.handleKeypadCodeEdited
        }, null, 8, ["modelValue", "label", "keypadCodeRequiredLength", "fullWidth", "alreadyUsedCodes", "disabled", "onErrorKeyCode", "onKeyCodeEdited"]),
        _createVNode("div", _hoisted_2, [
          _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("AppResourceEP.AccessCodeInstruction")), 1),
          _createVNode("div", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.$t(
                            "AppResourceEP.AccessCodeInstruction_Lenght",
                            [_ctx.currentEntrancePlant.keypadCodeRequiredLength]
                        )) + " ", 1),
            _hoisted_5,
            _createTextVNode(" " + _toDisplayString(_ctx.$t(
                            "AppResourceEP.AccessCodeInstruction_Consecutive"
                        )) + " ", 1),
            _hoisted_6,
            _createTextVNode(" " + _toDisplayString(_ctx.$t(
                            "AppResourceEP.AccessCodeInstruction_SameNumber"
                        )), 1)
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_InlineSvgScoped, {
            class: "svg-icon-alert",
            src: 
                            require(`@/assets/images/icons/icon-alert-medium-outline.svg`)
                        ,
            "aria-label": "icon-alert"
          }, null, 8, ["src"]),
          _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("AppResourceEP.ChangeAccessCodeLengthInfo")), 1)
        ])
      ]),
      _: 1
    })
  ]))
}